/**
 * Handles the mobile app prompt block.
 */
(function () {
    'use strict';

    const dismissalCookie = 'mobile_app_prompt_dismissed';
    const dismissalCookieMaxAge = 30; // 30 days
    const browserIcons = {
        safari: '/assets/artifacts/media/safari_logo-3.svg',
        edge: '/assets/artifacts/media/edge_logo-1.svg',
        firefox: '/assets/artifacts/media/firefox_logo-2.svg',
        chrome: '/assets/artifacts/media/chrome_logo-4.svg'
    };
    const defaultBrowserIconClass = 'icon-G11-Globe-World-Country';

    function setBrowserIcon(prompt) {
        const browserIcon = prompt.querySelector('[data-mobile-app-prompt-browser-icon]');
        if (!browserIcon) return;
        const browser = typeof window.getBrowserName === 'function' ? window.getBrowserName() : 'chrome';
        if (!browserIcons[browser]) {
            const defaultIcon = document.createElement('i');
            defaultIcon.className = `wu-icon wu-icon__md ${defaultBrowserIconClass}`;
            defaultIcon.setAttribute('data-grunticon-embed', '');
            defaultIcon.setAttribute('aria-label', 'Browser');
            defaultIcon.dataset.browser = browser;
            browserIcon.replaceWith(defaultIcon);
            return;
        }

        browserIcon.src = browserIcons[browser];
        browserIcon.alt = `${browser.charAt(0).toUpperCase()}${browser.slice(1)} browser`;
        browserIcon.dataset.browser = browser;
    }

    function wasDismissed() {
        return document.cookie.split('; ').some(function (cookie) {
            return cookie.startsWith(dismissalCookie + '=true');
        });
    }

    function markDismissed() {
        if (typeof setCookie === 'function') {
            setCookie(dismissalCookie, 'true', dismissalCookieMaxAge, '/');
        }
    }

    function showPrompt(prompt, overlay) {
        prompt.classList.remove('d-none');
        if (overlay) {
            overlay.classList.remove('d-none');
            overlay.style.display = 'block';
        }
    }

    function hidePrompt(prompt, overlay) {
        prompt.classList.add('d-none');
        if (overlay) {
            overlay.classList.add('d-none');
            overlay.style.display = 'none';
        }
    }

    function initPromptRating() {
        const country = window.pageData?.country;
        if (!country || !document.querySelector('[data-mobile-app-prompt-rating]')) return;

        if (typeof window.wuAppRatingsFetch === 'function' && typeof window.updateMobilePromptRating === 'function') {
            window.wuAppRatingsFetch(country).then(window.updateMobilePromptRating).catch(() => {});
            return;
        }

        const request = typeof window.fetchApiWu === 'function'
            ? window.fetchApiWu(`/staticassets/app-ratings/${country}-ratings.json`, { method: 'GET' }, 'starRatingApi')
            : window.fetch(`/staticassets/app-ratings/${country}-ratings.json`).then(response => response.json());
        request.then(function (response) {
            const androidRating = Number(response?.android?.average_rating) || 0;
            const iosRating = Number(response?.ios?.average_rating) || 0;
            const rating = Math.max(androidRating, iosRating);
            document.querySelectorAll('[data-mobile-app-prompt-rating]').forEach(function (ratingBlock) {
                const value = ratingBlock.querySelector('.rating-dynamic');
                if (!rating || !value) return;
                value.textContent = rating.toFixed(1);
                ratingBlock.classList.remove('d-none');
            });
        }).catch(() => {});
    }

    function initMobileAppPrompt(prompt) {
        if (!prompt) {
            return;
        }

        if (prompt.dataset.mobileAppPromptInitialized === 'true') {
            return;
        }
        prompt.dataset.mobileAppPromptInitialized = 'true';

        initPromptRating();
        const overlay = document.querySelector('[data-mobile-app-prompt-overlay]');
        const openButton = prompt.querySelector('[data-mobile-app-prompt-open]');
        const continueButton = prompt.querySelector('[data-mobile-app-prompt-continue]');
        const closeButton = prompt.querySelector('[data-mobile-app-prompt-close]');

        setBrowserIcon(prompt);

        if (wasDismissed()) {
            hidePrompt(prompt, overlay);
            return;
        }

        showPrompt(prompt, overlay);

        if (openButton) {
            openButton.addEventListener('click', function (e) {
                const openUrl = openButton.getAttribute('href');
                if (!openUrl || openUrl === '#') {
                    e.preventDefault();
                    return;
                }
                markDismissed();
                hidePrompt(prompt, overlay);
            });
        }

        if (continueButton) {
            continueButton.addEventListener('click', function (e) {
                e.preventDefault();
                // The popup is hidden immediately below. Log this CTA before
                // hiding it so the document-level analytics handler receives
                // the same target and amplitude-id as the other popup actions.
                if (typeof window.logClickEvent === 'function') {
                    window.logClickEvent(e);
                    e.stopPropagation();
                }
                markDismissed();
                hidePrompt(prompt, overlay);
            });
        }

        if (overlay) {
            overlay.addEventListener('click', function () {
                hidePrompt(prompt, overlay);
            });
        }

        if (closeButton) {
            closeButton.addEventListener('click', function (e) {
                if (typeof window.logClickEvent === 'function') {
                    window.logClickEvent(e);
                }
                markDismissed();
                hidePrompt(prompt, overlay);
            });
        }
    }

    function init() {
        document
            .querySelectorAll('[data-mobile-app-prompt]')
            .forEach(initMobileAppPrompt);
    }

    document.addEventListener('us_deeplink_redirect', function () {
        init();
    });
}());